import Vue from "vue";
import debounce from "lodash/debounce";
import { getSearchResults } from "../../client-app/src/common/api";

function initSearch() {
    var el = document.getElementById("hero-search");

    if (!el) return;

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        data: {
            results: null,
            loading: false,
            searching: false,
            showDropdown: false,
            geolocationLoading: false,
            geolocationError: false,
            currentQuery: "",
            hasGeolocation: navigator.geolocation ?? false,
            currentLocation: null,
            currentLocationUrl: null,
        },
        mounted: async function () {
            // console.log("👍 Hero search mounted");
        },
        computed: {},
        methods: {
            searchCurrentLocation: function (event, url) {
                event.preventDefault();
                this.showDropdown = true;
                this.geolocationLoading = true;
                this.currentLocationUrl = url;
                
                navigator.geolocation.getCurrentPosition(
                    this.gotCurrentLocation,
                    this.declinedCurrentLocation
                );
            },
            gotCurrentLocation: function (position) {
                this.currentLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                // this.fetchSearchResults(this.currentQuery);
                this.showDropdown = true;
                this.geolocationLoading = true;
                // document.getElementById('hero-search-input').focus();
                window.location.href =
                    this.currentLocationUrl +
                    "?lat=" +
                    this.currentLocation.lat +
                    "&lng=" +
                    this.currentLocation.lng +
                    "&search=" +
                    this.currentQuery;
            },
            declinedCurrentLocation: function (response) {
                this.geolocationLoading = false;
                this.geolocationError = true;
            },
            updateSearchQuery: async function (event) {
                const noInteract = [
                    "Escape",
                    "Shift",
                    "Enter",
                    "CapsLock",
                    "Meta",
                    "Control",
                    "Alt",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowDown",
                    "ArrowUp",
                ];

                // Only allow normal character input
                if (noInteract.indexOf(event.key) > -1) {
                    return;
                }

                this.searching = true; // show search loader
                this.results = []; // clear results
                this.currentQuery = event.target.value;
                this.fetchSearchResults(this.currentQuery); // fetch data
            },
            fetchSearchResults: debounce(async function (query) {
                // If we have a query, run it, else set results to "null" so we can display our "search current location" link
                if (query.length > 0) {
                    // console.log("fetch search results");
                    let result = await getSearchResults(query, this.currentLocation);
                    this.results = result.body;
                } else {
                    // console.log("results null");
                    this.results = null;
                }

                this.searching = false;
            }, 500),
        },
    });
}

export default function () {
    initSearch();
}
